import { BRANDS } from "./brands";

// Partners mock data. Backend: replace via partnersService.getPartners()
// Partner logos are rendered as branded typographic placeholders (no official
// logo files supplied). Replace `logo` with an image URL when available.
export const PARTNERS = BRANDS.map((b) => ({
  id: `partner-${b.slug}`,
  name: b.fullName,
  slug: b.slug,
  brandSlug: b.slug,
  website: b.website,
  logo: null, // placeholder — backend supplies logo URL later
  description: b.description,
  hasProducts: b.categories.length > 0,
}));

export const getPartnerBySlug = (slug) => PARTNERS.find((p) => p.slug === slug);
